<div
  class="h-[480px] chart-wrapper flex flex-col gap-y-2 bg-chart rounded-lg overflow-hidden relative"
  [ngClass]="wrapperClass"
  #wrapper
>
  <app-chart-loader-indicator *ngIf="isLoading"></app-chart-loader-indicator>

  <div>
    <div
      class="flex p-4 items-center z-10 justify-between border-b-2 h-[40px] border-gray-200 pt-5"
    >
      <h3 class="text-chartIconLabel font-semibold">{{ localizedTitle }}</h3>

      <div
        *ngIf="showValuePercentToggle"
        class="flex items-center gap-[4px] text-sm rounded-lg bg-white px-2 border-[1px] border-gray-300"
      >
        <span i18n="@@value">Value</span>
        <mat-slide-toggle
          class="scale-[0.6]"
          (change)="togglePercentOrValue($event)"
        ></mat-slide-toggle>
        <span i18n="@@percentage">Percentage</span>
      </div>

      <div *ngIf="showExpandIcons" class="flex items-center gap-3">
        <p *ngIf="showTotal" i18n="@@total" clasName="text-sm">Total:</p>
        <p *ngIf="showTotal">
          {{ total | currency : undefined : '1.2-2' : true }}
        </p>
        <mat-icon
          class="text-chartIconLabel scale-[0.6] cursor-context-menu chart-fullscreen-toggle"
          *ngIf="!isFullScreen"
          (click)="openCustomFullScreen()"
          svgIcon="fullscreen"
        ></mat-icon>
        <mat-icon
          class="text-chartIconLabel cursor-context-menu scale-[0.6] chart-fullscreen-toggle"
          *ngIf="isFullScreen"
          (click)="exitCustomFullScreen()"
          svgIcon="fullscreen_exit"
        ></mat-icon>
      </div>
      <p *ngIf="showTotalCount" class="font-semibold border">
        Count: {{ total }}
      </p>
    </div>

    <div [ngClass]="filterClass">
      <ng-content select="[filter]"></ng-content>
    </div>
  </div>
  <div [ngClass]="chartClass">
    <ng-content select="[chart]"></ng-content>
  </div>
  <div class="text-sm overflow-auto" [ngClass]="tableClass">
    <ng-content select="[table]"></ng-content>
  </div>
</div>
